module.exports = require('./dist/index');


//////////////////
// WEBPACK FOOTER
// ./~/react-spinners/index.js
// module id = 297
// module chunks = 53022663505114 79611799117203